var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,idx){return _c('div',{key:idx,attrs:{"syle":"margins: 4px;"}},[_c('div',[_c('b',[_vm._v(_vm._s(error))])]),_c('div',[_vm._v(_vm._s(_vm.errorText(error)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }